<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <div v-show="show"
                         class="alert alert-danger alert-dismissible fade show"
                         role="alert">
                        <span v-for="(err, index) in validation_errors" :key="index">
                          {{ err[0] }} <br/>
                        </span>
                    </div>
                    <form action="" enctype="multipart/form-data" files="true" role="form">
                        <div class="form-row">
                            <div class="col-md-4 col-sm-4">
                                <label for="caption">Caption <span class="c-required">*</span></label>
                                <input type="text" v-model="caption" v-validate="'required'" id="caption" name="caption" class="form-control form-control-sm" placeholder="Enter Caption"/>
                                <div class="invalid-feedback">Please enter caption.</div>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for="category_id">Category <span class="c-required">*</span></label>
                                <select v-model="category_id" v-validate="'required'" id="category_id" name="category_id" class="form-control form-control-sm" @change="getSubCategories()">
                                    <option :value="''" selected>Select a category</option>
                                    <option :key="index" :value="category.id" v-for="(category, index) in categories">{{ category.desc }}</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select a category.
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for="c_village_id">Sub Category <span class="c-required">*</span></label>
                                <select v-model="sub_category_id" v-validate="'required'" id="c_village_id" name="c_village_id" :disabled="category_id.length === 0" class="form-control form-control-sm">
                                    <option :value="''" selected>Select a sub category</option>
                                    <option :key="index" :value="category.id" v-for="(category, index) in sub_categories">{{ category.desc }}</option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select a sub category.
                                </div>
                            </div>
                        </div>
                        <div class="form-row mt-3">
                            <div class="col-md-4 col-sm-4">
                                <label for="file">Ses File <span class="c-required">*</span></label>
                                <input type="file" ref="file" id="file" name="file" @change="getFile()" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" class="form-control form-control-sm"/>
                            </div>
                            <div class="col-md-4 col-sm-4">
                                <label for="remarks">Remarks <span class="c-required">*</span></label>
                                <input type="text" v-model="remarks" v-validate="'required'" id="remarks" name="remarks" placeholder="Enter remarks" class="form-control form-control-sm"/>
                                <div class="invalid-feedback">
                                    Please enter remarks.
                                </div>
                            </div>
                        </div>
                        <button  class="btn btn-success btn-sm mt-3" @click.prevent="update">Update</button>
                    </form>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "SES Document Update",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "SES Document Update",
                items: [
                    {
                        text: "SES",
                        href: "ses/files"
                    },
                    {
                        text: "Dashboard",
                        active: true
                    }
                ],
                ses_id: "",
                seses: [],
                search_data: {},
                villages: [],
                categories: [],
                sub_categories: [],
                category_id: "",
                sub_category_id: "",
                sub_category: {},
                fileLengthExceeds: false,
                file: "",
                remarks: "",
                caption: "",
                sesFiles: [],
                btn_edit: false,
                id: "",
                validation_errors: {},
                show: false
            };
        },
        mounted() {
            this.getCategories();
            this.ses_id = this.$route.params.ses_id;
            this.onUpdate(this.ses_id);
        },
        methods: {

            update() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let formData = new FormData();
                        formData.append("file", this.file);
                        formData.append("category_id", this.category_id);
                        formData.append("sub_category_id", this.sub_category_id);
                        formData.append("remarks", this.remarks);
                        formData.append("caption", this.caption);
                        formData.append("ses_id", this.ses_id);

                        http
                            .post("api/ses/files/update/" + this.id, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "Content-type": "application/json"
                                }
                            })
                            .then(response => {
                                if (!response.error) {
                                    this.$bvToast.toast("Ses doc file updated successfully", {
                                        title: "Success",
                                        autoHideDelay: 5000,
                                        variant: "success"
                                    });
                                    this.resetForm();
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.show = true;
                                this.hide();
                                this.$bvToast.toast("Update Failed", {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            });
                    }
                });
            },

            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },

            getCategories() {
                http.get("api/ses/categories").then(response => {
                    if (!response.error) {
                        this.categories = response.data.categories;
                    }
                });
            },

            getSubCategories(category) {
                this.sub_categories = this.categories.find(
                    cat => cat.id == this.category_id
                ).sub_categories;
            },

            getFile() {
                this.file = this.$refs.file.files[0];
                if (this.file.size > 3072000) {
                    this.$bvToast.toast("File size not greater then 3 MB", {
                        title: "Error",
                        autoHideDelay: 5000,
                        variant: "error"
                    });
                    this.file = "";
                }
            },

            onUpdate(id) {
                http.get("api/ses/file/" + id).then(response => {
                    this.category_id = response.data.data.category_id;
                    this.remarks = response.data.data.remarks;
                    this.caption = response.data.data.caption;
                    this.id = response.data.data.id;
                    this.getSubCategories(this.category_id);
                    this.sub_category_id = response.data.data.sub_category_id;
                    this.btn_edit = true;
                });
            },

            resetForm() {
                this.$validator.reset();
                this.$refs.file.value = "";
                this.category_id = "";
                this.sub_category_id = "";
                this.remarks = "";
                this.caption = "";
                this.btn_edit = false;
            }
        },

    };
</script>
e>